import Link from "next/link"
import Image from "components/Image"
import Placeholder from "public/assets/team-member-placeholder.svg"

export default function TeamMember({ priority = false, full_slug, photo, name, credentials, title }) {
  return (
    <div className="text-center max-w-[184px]">
      <Link href={`/${full_slug}`}>
        {photo?.filename ? (
          <Image
            priority={priority}
            src={photo?.filename}
            alt={photo?.alt && photo.alt !== "" ? photo.alt : name}
            width="184"
            height="184"
            className="mx-auto w-full aspect-square object-cover object-top"
          />
        ) : (
          <Placeholder className="mx-auto w-full aspect-square object-cover object-top" />
        )}
      </Link>
      <Link href={`/${full_slug}`} className="py-2 hover:underline capitalize font-primary">
        {name}
        {credentials ? `, ${credentials}` : null}
      </Link>
      <div className="font-light">{title}</div>
    </div>
  )
}
